import type { CampaignStatus } from '../types/campaigns.types';

export const canEditCampaign = (status: CampaignStatus): boolean => status === 'Draft';
